import { render, staticRenderFns } from "./LicenceFile.vue?vue&type=template&id=07aec43a&scoped=true&"
import script from "./LicenceFile.vue?vue&type=script&lang=js&"
export * from "./LicenceFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aec43a",
  null
  
)

export default component.exports